<template>
  <zpa-column no-gutter class="filter-box">
    <slot name="title"/>

    <zpa-row padding="8px" style="justify-content: space-between;">
      <slot name="query"/>

      <zpa-row no-gutter style="flex: none;">
        <Tooltip content="筛选器">
          <Button @click="show = true" style="margin-right: 10px;">
            <Icon type="ios-funnel" size="17"></Icon>
          </Button>
        </Tooltip>

        <slot name="extra"/>
      </zpa-row>
    </zpa-row>

    <Drawer v-model="show" width="300" :closable="false">
      <zpa-row no-gutter>
        <Tooltip content="重置">
          <Button @click="onClickReset">
            <Icon type="md-refresh" size="20"></Icon>
          </Button>
        </Tooltip>

        <Tooltip content="查询" style="margin-left: 10px;">
          <Button type="primary" @click="onClickSearch">
            <Icon type="md-search" size="20"></Icon>
          </Button>
        </Tooltip>
      </zpa-row>

      <Divider>筛选器</Divider>

      <zpa-form inline ref="Form" style="flex: auto;" :label-width="64">
        <zpa-form-group middle inline>
          <slot/>
        </zpa-form-group>
      </zpa-form>
    </Drawer>
  </zpa-column>
</template>

<script>
export default {
  name: 'FilterBox',

  data() {
    return {
      show: false,
    }
  },

  methods: {
    onClickSearch() {
      this.$emit('search')
    },

    onClickReset() {
      this.$refs.Form.reset()
      this.$emit('reset')
    },
  },
}
</script>

<style scoped lang="less">
  .filter-box {
    button {
      margin-left: 8px;
    }
  }
</style>
